module.exports = __webpack_public_path__ + "static/media/no-image-provided.678046a0.png";